"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.LoadingStatusSpinner = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _styledBase = _interopRequireDefault(require("@emotion/styled-base"));

var _react = _interopRequireDefault(require("react"));

var _SpinnerSvg = require("../spinner/SpinnerSvg");

var _spinner = require("../spinner");

var _core = require("@emotion/core");

var LoadingStatusSpinnerBase = function LoadingStatusSpinnerBase(props) {
  return (0, _core.jsx)(_SpinnerSvg.SpinnerSvg, (0, _extends2.default)({
    color: "primary70",
    strokeWidth: 4
  }, props));
};

var LoadingStatusSpinner = ( /*#__PURE__*/0, _styledBase.default)(LoadingStatusSpinnerBase, {
  target: "eae68bd0"
})("animation:0.8s linear infinite ", _spinner.rotateKeyframes, ";" + (process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uLy4uL3NyYy9zdWJtb2R1bGVzL3N0YXR1cy1pbmRpY2F0b3IvTG9hZGluZ1N0YXR1c1NwaW5uZXIudHN4Il0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQWdCb0UiLCJmaWxlIjoiLi4vLi4vLi4vc3JjL3N1Ym1vZHVsZXMvc3RhdHVzLWluZGljYXRvci9Mb2FkaW5nU3RhdHVzU3Bpbm5lci50c3giLCJzb3VyY2VzQ29udGVudCI6WyJpbXBvcnQgUmVhY3QgZnJvbSAncmVhY3QnO1xuXG5pbXBvcnQgc3R5bGVkIGZyb20gJ0BlbW90aW9uL3N0eWxlZCc7XG5cbmltcG9ydCB7IFNwaW5uZXJTdmcsIFNwaW5uZXJTdmdQcm9wcyB9IGZyb20gJy4uL3NwaW5uZXIvU3Bpbm5lclN2Zyc7XG5cbmltcG9ydCB7IHJvdGF0ZUtleWZyYW1lcyB9IGZyb20gJy4uL3NwaW5uZXInO1xuXG4vLyBlc2xpbnQtZGlzYWJsZS1uZXh0LWxpbmUgQHR5cGVzY3JpcHQtZXNsaW50L25vLWVtcHR5LWludGVyZmFjZVxuaW50ZXJmYWNlIExvYWRpbmdTdGF0dXNTcGlubmVyUHJvcHNcbiAgZXh0ZW5kcyBPbWl0PFNwaW5uZXJTdmdQcm9wcywgJ2NvbG9yJyB8ICdzdHJva2VXaWR0aCcgfCAncmVmJz4ge31cblxuY29uc3QgTG9hZGluZ1N0YXR1c1NwaW5uZXJCYXNlOiBSZWFjdC5GQzxMb2FkaW5nU3RhdHVzU3Bpbm5lclByb3BzPiA9IChcbiAgcHJvcHNcbikgPT4gPFNwaW5uZXJTdmcgY29sb3I9XCJwcmltYXJ5NzBcIiBzdHJva2VXaWR0aD17NH0gey4uLnByb3BzfSAvPjtcblxuZXhwb3J0IGNvbnN0IExvYWRpbmdTdGF0dXNTcGlubmVyID0gc3R5bGVkKExvYWRpbmdTdGF0dXNTcGlubmVyQmFzZSlgXG4gIGFuaW1hdGlvbjogMC44cyBsaW5lYXIgaW5maW5pdGUgJHtyb3RhdGVLZXlmcmFtZXN9O1xuYDtcbiJdfQ== */"));
exports.LoadingStatusSpinner = LoadingStatusSpinner;